module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "ch01"
    }
  }, [_c('div', {
    staticClass: "chapterHead"
  }, [_c('h2', {
    staticClass: "chapterNumber",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chapter One")])])]), _vm._v(" "), _c('div', {
    staticClass: "chapterBody"
  }, [_c('p', {
    staticClass: "chapterOpenerText",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_vm._v("N"), _c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("OVEMBER")]), _vm._v(". The month of the dead. The dry death of field and thicket had given way to unending rains. Close to the Feast of St Martin in the fifth year of King Richard’s reign, the ditches were overflowing, the rivers in spate, the fields like vast lakes under a sullen sky.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Hildegard rode in darkness through lanes she knew well, picking her way across the marshes of Holderness, skirting gurgling dykes and the overflowing channels that divided the field strips until eventually she reached the quag that passed for the road to York and the limits of familiarity. Dawn came and a pale light drizzled over the landscape. Travellers hoping to enter the city as soon as the gates were opened were more frequent now and she joined the sombre flow.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("It was mid-morning when she rode under the Monk Gate and encountered the tumult of the town, late afternoon by the time she left her horse and two hounds with the ostler and hired a boat, and it was evening, prematurely dark in the foul weather, by the time she shipped the dripping oars and lay unnoticed under some overhanging willows a little way upstream from the archbishop’s palace. With the document from Rome hidden in the folds of her robe it was common sense to seek admittance via the watergate only under cover of darkness.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Night fell, with its swirling fogs and noxious airs. As soon as it was safe Hildegard entered secretly by the watergate and was admitted without delay into the presence of the archbishop. In his splendid robes he received her cordially, though with few words. When he held out his hand for the parchment, its seal dangling, she tried to gauge his allegiance by the glance he bestowed but he gave nothing away. Trembling a little at her own part in these weighty affairs, she was relieved to be shown to a guest chamber high up in the honeycomb of gilded luxury in which the prelate lived. A restless night on a pallet of soft wool followed. It was too unusual in its cloying ease to afford much sleep and next morning she was brought, pale and exhausted, to the second part of her errand.")]), _vm._v(" "), _c('p', {
    staticClass: "spaceBreak",
    staticStyle: {
      "text-indent": "0%"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "paraNoIndent",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_vm._v("It was shortly after prime and still dark by the time she slipped out through the watergate and sculled back downstream. The shock of the town when she returned to pick up her horse and hounds was overwhelming. Bellowing traders were advertising their wares from every corner of the marketplace, artisans displayed their stock in dozens of shops ranged cheek by jowl along the crowded streets, and the whole warren of the town was filled with musicians and conjurors, merchants and mountebanks, pardoners and herbalists, saddlers and friars mendicant, cloth merchants, wine and water carriers, sellers of meat, of bread, of cheese, and servants and pedlars of every conceivable kind. A hundred faces or more were grabbed by the light of flaring cressets then let slip back into the darkness. Animals added their own clamour, hens clucking, horses hobbled for purchase, beef bellowing on the hoof, goats, ducks, dogs and a dancing bear rattling its chain. And suddenly, as dawn broke, the rain began to fall. It sent awnings rattling over stalls and shopfronts as everyone rushed to avoid a drenching.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Such a mingling of sight and sound was almost too much to take in after seven years in a hermitage. Everybody, Hildegard realised, was here to buy and sell, including the girls hanging round the lighted ale-house in their low-cut gowns.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("As she began to push her way through the crowd towards the stables she heard the beating of a kettledrum start up on the other side of the marketplace. The drummer banged out the brisk rhythm of a marching band but instead of the expected accompaniment of pipes and horns a cacophony of crashes and rattles took up the beat. It was a parody of music, rapid and violent, and as the players approached through the rain in the glimmering dawn Hildegard craned her neck like everyone else to see who they were.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Between the heads she saw four or five musicians carving an avenue through the crowd. They were beating pots and pans, the spasmodic jerks of their clubs accompanied by smiles of glee at the racket they were making. The bailiff and his men paraded straightfaced beside them with their staves at the ready. As the crowd opened to let them through she saw that the vanguard of this noisy procession was taken up by three young girls tied together round the waists by a length of stout rope. On their heads they wore striped bonnets, enough to announce their profession even if their ragged attempts at sexual allure had not done so. Some of the onlookers applauded as the girls passed by and shouted in support, others yelled insults and one stallholder, face contorted in disgust, hurled a small yellowing cabbage. It hit one of the girls in the middle of the back and she flashed round at once.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Oh, it’s you, is it, lover? See you at your usual time tonight, shall I?’ The crowd near by roared with laughter and the stallholder, red faced, gave a snarl and turned away.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("An old ale-woman had come out from a nearby inn to see what had brought her customers into the street. She stood with folded, beefy arms, and Hildegard heard her suck in her breath. ‘Just listen to that!’ she said to anyone who cared to pay heed. ‘He’ll be getting a walloping from his wife next and serve him right.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘They’re such very young girls,’ Hildegard commented. ‘But I suppose if men pay girls will play.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The ale-wife turned to her. ‘That mouthy one’s seventeen. Been plying her trade some two years now. It’s the little one I feel sorry for.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The procession had drawn level and Hildegard could see the third girl dragging a little behind the two more brazen ones in front. She looked no more than thirteen. With a terrified expression she walked with her head down, allowing the two older ones to pull her along by the rope. ‘You feel sorry for her because of her youth, I suppose? asked Hildegard’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘And because of how she got into this predicament in the first place,’ answered the ale-wife.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘And how was that?’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Brought here from foreign parts by her so-called uncle. Big brute of a fellow. Set her to work straight away so he could sit on his backside and count her earnings.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Can’t she get away from him?’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘He’d track her down. She’s his little gold mine. He’d not let her get far.’ The ale-wife shook her head in despair. ‘Makes you think, though. She can’t be any older than young King Richard. Not a day more than fifteen. But a very different destiny allotted by God Almighty in his wisdom.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘I doubt whether even King Richard is content at present.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Aye, stuck with his uncles and their cunning. He’s as bound by riches as that poor lass by poverty, and that’s the truth. Those unless of his certainly see themselves fitted to rule more than a mere lad. Lucky for him he got the London mob on his side with his recklessness at Smithfield, don’t you think?’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘I suspect it’s made the council of dukes even more certain he’s not the fabric a king should be patched from,’ Hildegard replied somewhat guardedly.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Ah, there’s the stench of conspiracy everywhere you look.’ The ale-wife cast a gloomy eye over the busy marketplace. ‘We live in sad times. Where will it end?’ She turned to attend to her customers, swarming back now the procession had moved off, and Hildegard, too, turned to go. It was true what the ale-wife said about the king. Although Richard had been perched on the throne of England for five years, ever since the death of his grandfather Edward III, his uncles, the royal guardians, were roused to a conspiracy of ambition, especially now, after the way he had supported Wat Tyler and his followers during their confrontation at Smithfeld. The boy’s sympathies had not endeared him either to his uncles, the dukes, or to the barons, who saw their vast estates threatened by the mob. The burgesses, too, were sent into a panic of fear at the prospect of losing their grasp on the monopoly of trade in the towns with further civil unrest. King Richard’s apparent change of heart when he revoked his promises to Tyler and his followers, was said by some to have been forced on him by John of Gaunt under threat of losing his crown. Others saw it as an instance the boy-king’s duplicity.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Making her way between the stalls towards the stables where her horse and hounds were waiting, Hildegard was frowning. It was not only the State which was in turmoil. The Church was fractured by dissent as well. Wyclif was stirring justifiable debate but had been silenced by the council at Blackfriars the previous year. Authority everywhere was being challenged. The rival popes, Urban in Rome and Clement in Avignon, had divided Europe and managed to bring the English and the French into opposition yet again. As the ale-wife said, these were sad times and there was no knowing where it would end.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The sound of the procession had almost faded and after a brief lull the marketeers started shouting their wares with renewed vigour. By now the girls would be approaching the stocks on the far side where they would endure further humiliations. Hildegard sighed. There was little justice to be had when the purchasers of such girls ran free and as often as not wore the chains of law and order on their chests.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Disturbed and saddened, her thoughts in disarray as she wondered what, if anything, she could do, she took charge of her palfrey, checked that the two dogs had been fed, then paid off the ostler and headed out towards the town gate.")]), _vm._v(" "), _c('p', {
    staticClass: "spaceBreak",
    staticStyle: {
      "text-indent": "0%"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "paraNoIndent",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_vm._v("Despite the dangers of travelling alone Hildegard felt only eagerness as she left the clamour and conflicts of York behind and rode out towards open country. She was prepared as well as she could be to face the bands of masterless men who roamed the forests nowadays. The many mercenaries on the loose since the apparent end to the French wars had developed an acquired taste for robbery with violence. They attacked whomsoever they pleased. She set her mouth in a firm line. The small cross she wore, hand carved out of hazelwood, was little protection in such dark days, but her stave was as thick as a bowman’s wrist and her hunting knife had a long blade, recently honed. For extra assurance, she was accompanied by two hounds, a lymer for attack and a little kennet for the sharpness of its claws.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Two alert guardian spirits, they ran through the waving grasses beside the track within a whistle call.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The lymer went ahead. Answering to the dignified name of Duchess, she was a long-legged, rakish beast, with a heavy jowled head, floppy ears and an intelligent, melancholy expression. By contrast the kennet, Bermonda, was like a domestic table dog, shaggy, brindled and apparently docile. On closer scrutiny you could see a mouth full of sharp, close-set teeth and a complement of villainous-looking claws to match. Like Duchess, she had a good nose and could follow a track through anything, woodland or thick cover, and could mark a scent from any branch the quarry had brushed past, and, in fact, seemed able to pluck a scent from the very air itself.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The little animal would express her excitement as soon she found a scent to let everybody know. The lymer was different. Her purpose was to locate the secret hiding place of the quarry so that the huntsmen could bring up the hounds to flush it out, so she was trained to hunt in silence. Neither Duchess nor Bermonda would ever give up. Fear was something they might instil but was something they never seemed to feel. Although confident they would protect her, Hildegard decided to keep to the woods and avoid the highway.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She left the city under Walmgate Bar and took the road that led east over the Fosse river beside arable strips of manor land. After this the way to Meaux wended through the great forest of Galtres with its league upon league of oak and beech and then rose little by little to the chalk uplands of the wolds. The road was narrower there though still a well-worn track, and it would eventually lead to the distant town of Beverley with its great lantern tower lifted like a beacon over the flat fields. After that it was only a few leagues further to Meaux.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She soon left the white walls behind and rode alongside strips of winter crops. The hayward’s horn could be heard rousing the peasants to work, men, women and children pouring from their hovels at its command. Cursing the rain, the saints and the reeve himself, they stumbled along the lane, half blind with fatigue and hunger. She saw women walking barefoot through the mud, with sleeping children on their backs. A ragged man, bent double with some deformity, crept by on a stick. Another figure with head and shoulders covered by a sack against the rain muttered incoherently to an unseen persecutor and picked a stumbling path around the puddles.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("After weeks of endless rains the field strips had been turned to mud. They were now nothing but stagnant corrugations, stretching into the grey distance, impossible to drive the oxen through. Even the strips on the higher ground were water-logged; the heavy clay stuck to everything it touched. A girl, clearly pregnant, emerged from one of the hovels that clustered along the side of the road. She was carrying a mattock. Working such land must be a back-breaking task, Hildegard thought with compassion as she rode by. From behind the curtain of rain came the keening of a dog to give voice to the general wretchedness.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("A better time will come, she thought. It must. It was imminent. Surely the signs were beginning to appear?")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She left the fields and entered the wasteland. Here the sky seemed vast. Black clouds raced across it from the east, big bellied with more rain. Tucking the flapping edges of her cloak tightly into her belt she rode on, deeper still into the wilderness. She began to consider the task that lay ahead.")]), _vm._v(" "), _c('p', {
    staticClass: "centerImage"
  }, [_c('img', {
    staticClass: "epubimage",
    attrs: {
      "alt": "image",
      "src": "Images/sp.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "paraNoIndent",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_vm._v("After the death of her husband in France was finally confirmed, Hildegard had emerged from seclusion in her hermitage at the Derwent Crossing determined to get on with life. She still longed for Hugh and had found no respite from her grief in prayer and meditation. There seemed little point in anything without him, but she knew she had to find a purpose. There was no excuse now. When the lawyers had finished picking through his estate, she had received a handsome fortune in rents and gold. It made her seek some use for such unexpected wealth. Then she had discovered what quickly became her life’s purpose: she would set up her own house of nuns where she could teach the young and tend the sick. It seemed the best she could do in the confusion of the times when the poor were being ground underfoot by one faction after another. Her prioress had given her stout support. There was only one obstacle to her desire: the Abbot of Meaux.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("In the short period of his abbacy Hubert de Courcy had established a reputation for austerity in keeping with the ideals of his order’s founder. Discipline had been restored, harshness towards the novices became ingrained. Those who didn’t like it left. The nuns at Swyne had soon discovered he was a man skilled in jurisprudence. He had several times represented the interests of his monks at the court of the King’s Bench in London to the priory’s detriment, had set up claims and counter-claims over land disputes all over the county. It was rumoured he was hoping to submit a plea to the French pope in Avignon as soon as he was summoned.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("It was also true that he had revitalised the abbey’s fortunes to something like their former health after the pestilence had carried away half the conversi and most of the monks a generation ago. And it seemed he could draw bequests to his order by the glitter of his silver tongue as easily as bees are drawn to the flower.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Even Hildegard’s prioress had been moved to narrow her eyes and in acid tones let fall the observation that "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("fiscal restraint")]), _vm._v(" was a phrase much heard at Meaux these days. ‘It seems,’ she said, ‘this new abbot they’ve pushed in over the head of the old one – Hubert de Courcy as he’s pleased to call himself – is something of a tough nut. But we shall see, no doubt of that.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Pondering on the best way to approach him, Hildegard entered the dank and dripping woods.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She hadn’t gone far when her thoughts were diverted.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("From far off came a sound that started as a distant shrill of birds but gradually it began to fill the woods with a raucous screeching. A flock of crows, she guessed. She wondered what had disturbed them. Looking to left and right, she soon saw a living cloud rising and falling above the trees to one side. Turning the head of her palfrey, she deviated from the path and rode on into the thicket until the source of the disturbance came into sight.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Five bodies hung from a gibbet set among the trees. Little was left to show that the bloodied shapes hanging there had once been human beings. The crows had picked and fought so thoroughly to finish the job started by men that their entrails spilled to the ground like ribbons the crows clinging to them as they bit and fought to get the biggest share. Their beaks ripped without remorse at the hunks of flesh they had dragged into the grass while their companions at the feast gnawed at eye sockets and sucked them clean of jelly. Others cracked through the tender bones of fingers or gorged with bloodied beaks on the yielding parts of breast and groin.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Hildegard wanted to avert her eyes but was transfixed by the sight. Her skin broke out in a sweat of horror. The men would have been alive when their guts slithered out after the thrust of the butcher’s knife. They would have been alive when they were swung into the air by their necks. But they would know nothing now of their life blood, leaking into the puddles on the scuffed earth beneath the gibbet where they must have struggled against their executioners.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Still unable to look away, she slid down off her horse out of respect and offered up a prayer. Her heart was thumping and her throat felt dry. There was nothing to be done for the victims now but pray. As she stepped forward she stumbled between two crows fighting over a piece of flesh. Their oiled wings lashed like weapons as they hooked their beaks over the same strip of human meat, until a blow from her stave broke up the fight. The reprieve lasted only moments, however. As soon as she remounted and began to push on through the undergrowth they started up again, as ferocious as before. She urged her horse onward, anxious to get away as quickly as possible from a scene of such bloody butchery.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("But the horror was not yet ended. Riding on between the hawthorns that parted as her horse thrust forward, she emerged into a sudden clearing. It was like a secret room in the forest. Before she could get her bearings and return to the track she caught sight of something bright in the trampled grass. Her nostrils quivered with the stench of fox. Duchess came to attention by her side but remained silent. Bermonda whined.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("A vixen, stunned by her abrupt appearance, quickly regained its senses and skidded back into the undergrowth. It too had been feasting and again the prey was human. On the ground was a man. That he was dead was obvious. His throat had been ripped out.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("As she slid from her horse for a second time the clouds opened and the rain began to fall harder than ever. Suddenly the woods were bristling with the sound of falling water. Dragging her hood over her head, she waded through the wet grass.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He was young, she saw, no more than twenty, a squire for some local lord maybe, wearing no blazon nor any other sign to show to whom he belonged. He might be an apprentice from the town, she thought, seeing his leather jerkin and roughly woven shirt. He wore no spurs, nor did he carry arms, and he bore many wounds besides those of the fox, which must have discovered him only moments ago. Many attackers armed with steel, she realised, in order to overcome just one young man.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Looking off to the edge of the clearing she found it impossible to make out which way the gang had ridden off. The glade was deep in mud, the grasses ground up in the turmoil of the attack. Now the pelting rain was filling the deep grooves left by the horses’ hooves. A rank smell of decomposing earth was released by the downpour.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Some masterless men must have done this, and only a short time ago, she surmised with a shudder. She had heard nothing above the raucous shrieking of the carrion, nor seen anything. A lone rider, she imagined, maybe on an errand for his master, the brigands seizing their chance? Or was it something to do with the hanged men at the town gibbet?")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She knelt down and rested a hand on the youth’s forehead. Already cold. And fair of face despite the bright neckerchief of blood at his throat. He was a youth with the ruddy cheeks of one used to the outdoors. No clerk, then, no journeyman working at his bench through all the hours of daylight. A wide mouth with full lips given to laughter. Blood bubbling and just beginning to clot at the corners of his mouth. The robbers had stolen their victim’s dagger from his belt, she observed, leaving the sheath empty.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The rain was rattling through the branches, setting up a roar in more distant parts of the woods like an army on the march. It reduced everything, even the lifeless body at her feet. She gave him a closer look before she left. There seemed nothing else to note. A prayer for his departed soul fell from her lips. Her eyes glistened. About to ride on to seek help in getting him taken to burial, she hesitated.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("There was something she had nearly missed. It was held tightly in his right hand. Tentatively she reached down. His body was not yet fixed in the rigour of death and she was able to prise his fingers apart one by one. Giving up what had been grasped so fiercely at the moment of death, his fingers softly opened.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He had been gripping a glass phial of some sort, no more than four inches high, with a wooden stopper sealed with red wax. The light was too bad to enable her to see what was inside the little bottle so she put it into the leather scrip on her belt together with her cures. It might be a clue to the young man’s identity, or to his destination, or even to the thwarted purpose of his journey through the woods.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("There was not much more she could do for him now. She dragged his body into the bushes and found a way of hiding it under some fallen branches to save him from the immediate notice of crows, then she stationed her lymer as a guard against ravening foxes until she could procure help from the monks. The abbey could be no more than two leagues away. With everything ordered as best she could, she took to the trail at once.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Shivering with cold, soaked to the skin, and with a heart filled with the horror of what she had seen, she was eventually conveyed over the wooden bridge that spanned the canal and rode on under the limestone archway into the sombre gatehouse of Meaux.")]), _vm._v(" "), _c('p', {
    staticClass: "spaceBreak",
    staticStyle: {
      "text-indent": "0%"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "paraNoIndent",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_vm._v("There was an air of excitement within the abbey. Townsfolk, a good many of them women, were flocking around the open doors of the chapel. They held scarves over their heads and the rain seemed to make them skittish. Their frivolity struck a jarring note. Hildegard’s thoughts were with the dead youth lying in the grass. From inside the chapel she could hear the sound of an organ growling out a flourish of arpeggios. A bell tolled briskly from the tower as if to hurry the already hurrying congregation. Catching a passing novice by the sleeve, Hildegard asked what was going on.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘The talking crucifix has been unveiled and the abbot is about to give a sermon. It’s not to be missed!’ He was full of enthusiasm. ‘Who knows, sister, we may be in luck and the crucifix will speak today! You’re fortunate to have arrived in the nick of time!’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Hildegard repressed any observation to the contrary. She watched the young man hurry away after pointing her in the direction of the office of the lay brothers, the conversi. By the time she had fulfilled her obligations to the murdered youth the sermon, together with any conversation involving crucifixes, would be over. But first she had to find the master of the conversi who ran the practical affairs of the abbey, and inform him about the body. Then she would have to guide his posse of men to the spot in the woods where she had hidden it, then, finally, in sorrow, bring it back to sanctuary.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She set about pushing a way through the crowd towards his office.")]), _vm._v(" "), _c('p', {
    staticClass: "spaceBreak",
    staticStyle: {
      "text-indent": "0%"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "paraNoIndent",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_vm._v("There were logs heaped on the fire, tapestries on the walls, and an obedient clerk in the corner taking notes. The heady scent of incense brought expensively from the east filled the air with a sense of luxury, as if to underline the fact that Abbot Hubert de Courcy had no need to make concessions to anyone. He had all the wealth and power of Avignon behind him.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Hildegard observed him without expression. In his late thirties, around her own age, in fact, and equally tall and vigorous in his manner, he was, of course, tonsured. No doubt if he had been a mere lay brother his hair would have been worn long, but it was clipped and dark and in its beauty matched his features. These were chiselled, even vulpine, helped by a Norman nose, cutting cheekbones and a sensual curl to the upper lip that women seemed to find irresistible, judging by the congregation earlier. None of this did him any good now. Hildegard merely watched him with a glance as cool as the rain that fell in the garth. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("I will not give in.")])]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He was a subtle and disputatious thinker, endlessly finding objections to her request.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("In fact, after informing him of the body in the woods and hearing him tell his clerk to send someone to fetch the coroner from York, they had been politely fencing since tierce. He seemed to find her request regarding the small priory she wished to establish quite unfeasible.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He simply refused to yield.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Now she fingered the small wooden cross she wore and reordered her thoughts. She was still shaken by her journey here. First the hanged men, the flock of carrion, then the youth and the fox. Nature itself seemed to be turning against man. The Church tried to explain it by saying it was because the Antichrist was approaching. Whatever the case, the murdered youth had been brought back to the abbey in the implacable rain and placed in a side chapel until the coroner arrived. Since then she had been forced to sit here countering endless objections from Hubert de Courcy. She was tired. She had scarcely had time to wash and change. There was mud in her nails and on her boots. The latter besmirched the abbot’s polished tiles, as she was sure he had already noticed.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("As she listened to him picking through his objections yet again she began to realise he must have misunderstood, for he was saying, ‘This is a man’s world, Sister. Alas for you, we don’t have nuns throwing their weight around within the abbey precincts. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Absit invidia")]), _vm._v(".’ He bowed his head a fraction, as if to take the sting out of his words. ‘You can hardly expect me to flout the directives of St Bernard at your behest.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘I thought you did what you liked, my lord abbot, within the Rule?’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘With two popes I suppose we could have a freer rein.’ He paused as if struck by the novelty of the idea before mentally placing a colon and adding: ‘Nevertheless, my dear sister, I administer the rules. If you want to be an abbess you’ll have to go elsewhere.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Hildegard frowned. Surely he didn’t imagine she wanted to set up here? ‘I don’t seek to rival anyone, my lord. I simply want to establish my own small house in accordance with my vision.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Hubert arched his fine, black brows.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘But I need your permission if I’m to fulfil its command. Meaux is our mother house,’ she reminded him. ‘I need your permission if I’m to go out and look at suitable property, and if you object only on grounds of proximity, that to have half a dozen nuns on the other side of the canal would be unsettling to you and your brothers, maybe we could discuss the matter of location instead?’ She ignored the iciness of his glance. ‘I have one or two granges in mind, my lord, ones at a distance to satisfy your need for solitude. And ours too,’ she added. His brows rose again. ‘I feel sure that when you see how hard working and sensible we are you won’t regret giving us your support.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("His brow, she noticed, furrowed even more as it began to dawn on him she wasn’t going to give in. His first objection on the grounds of danger had been countered. It was, she had agreed, dangerous for anyone, especially a woman, to travel the roads at these unsettled times. But she was prepared and able to defend herself. He had raised his eyebrows at that too. His next objection concerned the proximity of the new house. But she had made it absolutely clear she was as unwilling to set up on his doorstep as he was to have her do so. Now, she thought, any further objections would show he was simply being obstinate. If he persisted, it would soon become known, the prioress would make sure of that.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘The point is, my lord,’ she felt constrained to go on, ‘I don’t intend to lay myself or my sisters open to harassment from Scots mercenaries, like those poor nuns up at Rosedale Abbey, not only having to herd sheep and live on berries, poor things, but at risk from any marauders that happen along. My suggestion is: allow me a tour of houses in the Riding, then I can assess which one will be safest for me and my sisters and will benefit us all with a new regimen. I thought, perhaps, I could begin with that little nunnery out at Yedingham—’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Yedingham?’ He visibly relaxed. It was quite far away. She saw the thought flit across his face. But he was obdurate. ‘Unfortunately it’s Benedictine, as I’m sure you know – although a quite charming little place,’ he added cautiously.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Yes. We sisters at Swyne think so too. Luckily for us the lord who endowed it is favourably disposed towards Cistercians.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("His glance sharpened. To him that would mean Avignon, not Rome, Charles of France, not Richard, King of England. It would also raise the question of how she knew the preference of this generous magnate.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘As well,’ she continued, as if unaware of all this, ‘it’s on the north bank of the Derwent—’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Ah,’ he said. ‘The Derwent.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Regardless, she went on, ‘—and as the incumbents are getting on in years I gather they would welcome somebody with energy to run things for them – they even had a corrodian organising the dairy for them a few years ago, I understand – and of course we could take over the wharf there and see that it’s maintained in a manner you would appreciate.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He looked startled. ‘That means taking charge of the wine imports?’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Why, yes, if you insist. And apparently there are many hives—’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Thriving honey trade, true.’ He frowned.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘And plenty of swine, sheep and milch cows.’ She thought she’d better get it all out straight away.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Milch cows,’ he repeated, his tone suddenly heavy with foreboding.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Oh, and all manner of interesting fish in the river as well as oysters and a good few orchards close at hand, so I believe, and—’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘And the passing trade to the coast for which you might offer your services as guides—?’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Was that sarcasm? She ignored it. ‘And toll-keepers, yes. How clever of you to think of that!’ She sat back. What would he say? There was a pause while she held her breath.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘And failing Yedingham?’ he managed on a sigh, as he seemed to realise how well she had prepared her defence.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She leaned forward and gave him her warmest smile. ‘If you really couldn’t bear a group of capable nuns on the other side of the canal at Meaux – why, I suppose we could always look at Wilberfoss.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("His eyes flashed. ‘The niece of the archbishop runs Wilberfoss.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Oh dear, so that’s not possible. It will have to be some other place then. I’m sure we’ll find somewhere.’ Unable to resist a final thrust, she added, ‘Of course, I hope your mind isn’t entirely closed to the idea of a double house here at some time in the future? Recall the success of the one at Watton, my lord abbot.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘The Gilbertines are in there.’ His tone was dismissive. But his expression was of a man finding himself inexplicably hog tied.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Which demonstrates,’ she continued smoothly, ‘that we can all learn from each other. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Divisiones vero gratiarum sunt")]), _vm._v("—’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘There are diversities of gifts,’ he agreed heavily, ‘"), _c('em', {
    staticClass: "italic"
  }, [_vm._v("idem autem Spiritus")]), _vm._v(" – but the same Spirit. Oh indeed, Sister, yes, how true.’ Another deep sigh issued from his lips, as from a man setting out upon a rocky path instead of the easier one anticipated. ‘And may I take this opportunity to tell you how delighted I am,’ but no smile flitted across the marble features, ‘that your husband, Sir Hugh, had the forethought,’ he bowed his head and crossed himself, ‘before his heroic demise in the wars with France, to make such ample provision for you. There can be nothing worse than being a woman lacking either a husband or a fortune. And now,’ he bowed his head again, ‘without the one, you have the other.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Yes,’ Hildegard agreed. ‘You can’t imagine how restoring to the soul it is to have the power to endow a religious house and organise it exactly as one would wish.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘No,’ agreed the abbot, gloomily. His handsome features looked as if they would never break into a smile again. She rather pitied him, although not enough to forget they were still locked in battle.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘We religious,’ she continued, still aware that he scarcely took her proposition seriously, ‘are the bulwark against the rising tide of barbarity, allies at the outposts of civilisation. Indeed, the grotesque forces of chaos are only held at bay by we monastics. We must all pull together, my lord abbot.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘And with such a fair ally, Sister, who could be more certain of success?’ He seemed to have come to a decision to concede a temporary defeat. It must be obvious she had run rings round him. Retrenchment was the sensible course. He would have realised she could be useful if he kept on her good side. Her priory, though small, ran a productive silk trade and somehow the prioress managed to attract regular bequests of land. It was a point he would be stupid to ignore when his abbey’s need for grazing land was a pressing concern and they at Swyne had so much of it.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He spread his hands as if offering largesse. ‘So there it is then.’ It seemed as far as his pride would allow him to go.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘I have your permission, my lord?’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He gave a curt nod.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("So he has a soft centre, she noted with delight, even if he is a sarcastic devil at heart.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("His clerk had been assiduously copying down every single word they said. Now he was wiping his quill, well satisfied with himself. There would be many things I would change in the unlikely event I became abbess here, she thought as she prepared to take her leave. This clerk, for instance. He’d be better off working down at St Giles for a spell, with the lepers. That would teach him to be so sedulous in his note-taking. Hubert could not renege on having given his permission now it was written down in the abbey records.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("There was a flurry for the quill and tablet again as the abbot, almost as an afterthought, said, ‘Of course, sister, you could always talk to Lord Roger de Hutton. He’s bound to have an empty property that would suit you.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Hildegard levelled her glance. Lord Roger’s lands were distant. Hubert de Courcy might just as well have told her to go hence to Uttermost Thule. But she kept this thought to herself and smiled instead. ‘That’s an excellent idea, my lord.’ For a moment she toyed with her plain little cross until she noticed his glance, held as if hypnotised by the movement of her fingers. It made her wonder whether she had inadvertently led him to imagine unhasping it and letting it slither and…Not wanting to be damned for all eternity, she rose hurriedly to her feet.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘This has been most helpful, my lord abbot. I shall keep you informed of my progress.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("His morose smile followed her to the door, as if to say: I don’t doubt it. What he in fact uttered was merely a reminder to attend the inquest when the coroner appeared.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The bell for vespers was already booming out across the garth, making the glass in the lancet rattle. The sound seemed to bring him back from a reverie and he became his customary brisk self. ‘Before you leave, dear sister, will you join us at high table?’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Hildegard, thinking he would never ask, graciously accepted.")]), _vm._v(" "), _c('p', {
    staticClass: "spaceBreak",
    staticStyle: {
      "text-indent": "0%"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "paraNoIndent",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_vm._v("What the abbot said was true: Roger de Hutton had a finger in most pies, and if there was a suitable grange going begging he would probably own it. He owned almost everything that didn’t belong to the monastery and, in the opinion of many, would be wise to allow a handful of devout and useful women to pray for his soul’s ease.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Contrary to what the abbot might believe her heart was not entirely set on taking over Yedingham. It had been founded as a Benedictine nunnery but was so ill managed that Robert de Brus had been asked to take over. He was indifferent to the orders so long as they promised to offer prayers for him – politics were where his energy lay – and, with Lord Roger on her side, Hildegard was sure she could persuade him to let her take the lease to Yedingham. But it wasn’t perfect. For one thing it was quite remote, at least two days on foot to York, the nearest large town. The advantage of Meaux, and the reason why, despite her words, she hadn’t given up on the ambitious dream of having it turned into a double house, nuns on one side of the canal, monks on the other, was that it was only an hour’s brisk walk from Beverley with its thriving market. By horse it was even less, of course. She thought it prudent to bear such facts in mind.")]), _vm._v(" "), _c('p', {
    staticClass: "spaceBreak",
    staticStyle: {
      "text-indent": "0%"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "paraNoIndent",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_vm._v("It was in a thoughtful mood that Hildegard prepared to set out the next morning. A messenger had arrived from York to tell them that the coroner was busy on important business and could not attend within four days at the earliest. The general opinion was that the feast in celebration of St Martin was the only important business that kept him in York, but she decided to take advantage of the delay, for now it gave her time to ride to Castle Hutton to seek Lord Roger’s help.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("As she had told Hubert de Courcy, she did not intend to bury herself and her sisters in some godforsaken wilderness where they had only each other for company. They’d go mad as well as being prey for brigands. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("You can’t be the Abbess of Meaux, sister. I’m the abbot")]), _vm._v(", he had said. Well, she didn’t want to be at Meaux with him and his cronies breathing down her neck if that was his attitude. And Yedingham was good. Meaux was better. But there might be somewhere even better than both. She would take his advice then. She would consult Lord Roger.")]), _vm._v(" "), _c('p', {
    staticClass: "spaceBreak",
    staticStyle: {
      "text-indent": "0%"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "paraNoIndent",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_vm._v("Leaving Meaux shortly before dawn, she was pleased to find that the rain was holding off for the time being. She proceeded for the rest of the day through the forests of the high wolds in a haze of autumn gold. The air was sweet with the scents of the forest. Leaves lay in drifts underfoot, muffling the sound of hooves. Wrapped in her cloak, she travelled unworried, in the knowledge that there was little chance of coming across another gibbet in such a sparsely populated region. The few hamlets she came across were small, without even the benefit of stocks, and for the most part the only habitations were simple assarts, wooden shacks set in the midst of new clearings where the foresters and their families could live close to their work. If she had a fear it was of wolves. Packs of them scoured the wolds at this time of year. At least there is plenty of game, she observed, and I’ll have to trust that their attentions won’t turn to human flesh. The worst predators will be men, she decided. She sent the lymer on ahead to scout the trail for signs of outlaws. Then, close to nightfall, she took shelter in an abandoned barn, dined on rabbit brought down by the running dog, Bermonda, endured a fitful night’s sleep wrapped in her cloak with the two hounds pressing close for warmth on either side, then set out again at first light.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Soon a familiar landscape came into view. It brought a tender gleam to her eyes. It had been seven years since she had set foot in the old place. It was another life, one she had lost for ever. She had no regrets, however. With her husband dead and her two children now old enough to make their own way in life, what better occupation could she have than the one she had chosen? But it would be heart-warming to revisit her old haunts once more.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The November mist that lay along the bottom of the dale began to thin as she travelled higher, and soon a fine rain began to penetrate her clothing and set beads of pearl in her horse’s mane. With her hounds ranging wide through the undergrowth, she was on the point of emerging from the trees above the main track when she reined in with a sudden low whistle to bring Bermonda and Duchess to heel.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("At the bottom of the dale a well-trodden path wound through a grove of oaks. Owing to the rain it was churned to a river of mud. It was empty now. But the drumming of hooves could be heard in the distance and soon a stream of Saxon oaths, followed by the faint jingling of harness, came to her ears. Then she heard the distinct sound of a woman’s laugh. Hildegard and the hounds withdrew behind a hawthorn brake and waited.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Their attention was rewarded when a band of horsemen burst into view. They came roaring out of the trees, lathered in mud and sweat, and at their head, resplendent in shining mail, a knight. His horse had socks of mud to its withers and its caparison of silver and green was besmirched most foully but this did not in any way detract from the glamour of the knight’s appearance. He was followed by the laughing woman astride a spirited little mare. It, too, was caked in mud. At a word from her the whole crowd skidded to an untidy halt in the clearing.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Visitors to Hutton, Hildegard surmised, dazzled by the sight. The idea of visitors was pleasing. It might turn out to be a perfect time to ask a favour: Roger, the genial host, lavish with his hospitality, replete with manorial holdings – and generous to the requests of nuns.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Intending to go down to greet them, she saw the woman on the muddy little palfrey push back her hood with a gloved hand to reveal dark hair plaited in the Norman style. Then her voice floated clearly through the trees. It was light and amused. ‘This is where I’d better get into the litter, sweeting. Out of sight of prying eyes.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Hildegard hesitated. She saw the woman slip down from the mare into the arms of an eager servant with scarlet tippets on his sleeves and, with little cries of disgust, squelch back along the muddy track to a litter piled with furs hitched between two ponies. Adjusting her cloak, she flung herself on to it and, burrowing beneath the furs, commanded the troop to continue. More slowly now, they moved off.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Hildegard watched them go. ‘Whose prying eyes?’ she wondered aloud. Without answering, the two hounds followed her down the bank to join the trail on the final leg to Hutton.")]), _vm._v(" "), _c('p', {
    staticClass: "spaceBreak",
    staticStyle: {
      "text-indent": "0%"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "paraNoIndent",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_vm._v("It was dark when she arrived. Rain had been falling heavily for the last two hours. But even the weather could not destroy the impact of her first sight of the castle again.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("It stood at the head of the dale and rose up gleaming white like the side of a chalk cliff from amid the tall forest beeches, its four towers alight with flaring cressets in every sconce. On the battlements she noticed the glint of arms and heard the commands of the serjeant as the watch patrolled. The drawbridge was down but guards were posted on both sides of the moat to check who went in and who came out. She was allowed across with no difficulty when they saw she was a harmless nun. A lad hurried forward to take her horse.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("When she reached the gatehouse, however, the porter barred her way with a stick, hefting a torch so he could look into her face.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘I wish to have audience with Lord Roger,’ she told him, momentarily dazzled by the light.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘I ain’t got no instructions as such,’ he replied with a scowl.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘That’s because he doesn’t know I want to see him,’ she explained.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘I don’t know neither.’ He looked undecided when she refused to budge. Then he called over his shoulder to one of the sub-porters. ‘Here, go and ask yon steward if I’m to let her in.’ He jerked his thumb at Hildegard.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She was impatient now. Her boots were pinching and her cloak seemed to draw rain rather than repel it. Besides, Bermonda was whining for food and warmth and her little whimpers broke her heart.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Look, you can see I’m a harmless Cistercian,’ she tried again. ‘What’s the objection?’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘I’m only doing my job, Sister, just as you do yours.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Over his shoulder she could see straight into the bailey. There was a great confusion of serfs going back and forth. It looked busier than anticipated. She was desperate to get inside, take her wet clothes off and don dry ones. But the porter, it seemed, was not to be hurried.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘What’s all this about?’ she asked conversationally while they waited in the flickering light for the sub-porter to fight his way to where the steward was bawling orders at a line of servants.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘It’s Martinmas,’ he told her. Apparently relishing a chance to display his knowledge, he leant forward in a miasma of raw onion and garlic. ‘Security’s tight just now, Sister. My lord has his family and guests to protect. Everybody’s on the road at this time of year, with the hiring fairs and that. And down in the village they’re celebrating their own saint, Willibrod, and electing a mock mayor. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("And")]), _vm._v(", if that’s not enough, we’ve got some Lombardy prince and his four henchman come all the way from abroad to talk loans!’ He leaned back as if to say: so what do you think to that?")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘It’s certainly a hive of activity,’ Hildegard remarked, ‘and you at the centre of it all.’ She was rewarded by a toothy smile. ‘I can quite understand why you have to be so strict about anyone entering the castle but,’ she lowered her voice, ‘it must be a hefty loan Lord Roger’s after to bring the Lombards all this way up north. I thought he was doing quite well. Why does he want a loan, do you think?’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘They’re not just here on my lord’s account. They’re doing the rounds of the abbeys.’ The porter gestured northwards, then tapped the side of his nose. ‘Staple,’ he mouthed.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Hildegard widened her eyes. This was news. ‘Is the pope still after a bigger cut?’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘He wants the lot this time round. To get the better of Clement!’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘The monks won’t be pleased. They rather favour the French pope, I understand.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The porter chortled with delight at the prospect of a massacre to come, symbolic though it would be. He probably thinks mutual excommunications have been the best of it so far, she thought, each pope, Urban in Rome and Clement in Avignon, trying to outmagic the other. In her opinion there was worse to come. She turned to matters closer to hand. ‘I can’t stand here till Lauds. Let me through. I’ll put you right with the Lord Steward. He knows me of old.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘I can’t do that,’ began the porter, but Hildegard had already sidestepped his stave, slipped through the snickel gate and, her hounds with bared teeth in close order about her, had entered the seething crowd.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The steward was easy to spot. He was six foot three at least, clad smartly in ermine and pers with a chain of office visible round his neck. ‘Ulf!’ she called as soon as she was within earshot. ‘It’s me!’ Rain was pounding down in a fury now, sending people running for shelter, but when he turned she pushed back her hood to reveal her face framed by its gleaming hair.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He stopped in mid-shout and came wading towards her with arms outstretched.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘My sainted sister!’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Impervious to the bucketing rain, he swept her into his arms in a crushing embrace. ‘When they said there was a nun at the gate I didn’t suspect it was you! I can’t believe my eyes! Are you real? Have they turned you out of Swyne? Is everything all right?’ He gave her a close look.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Everything’s fine. Apart from something that happened on the way over. I’ll tell you about that later.’ Hildegard glanced at the crowd scurrying about the bailey. ‘I was hoping for a quiet word with Lord Roger,’ she said, ‘but it looks as if he’s going to have no time if your porter’s to be believed.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Fear not, sweetheart. He’ll see you any time.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She gave him a sharp glance. ‘Wife number five permitting?’ News of Roger’s recent marriage had reached the priory almost before it was planned.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Don’t worry about Lady Melisen,’ Ulf said. ‘She’s Norman through and through. Knows the price of everything. A pleasure to do business with. She won’t consider it worth her while to get in your way. What do you want with Lord Roger?’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘It’s a long story. Let me get out of these wet clothes. But what’s all the fuss about?’ She gestured towards the melee of porters, sumpter ponies, kitchen staff and serfs. They were now augmented by what must surely be the five Lombardy men sauntering elegantly across the garth towards the refectory beneath a canopy held over their heads by a couple of soaked and grimacing servants.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Following her glance, Ulf grinned. ‘Loan men,’ he confirmed. ‘Smart, aren’t they?’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The black-clad Lombards were looking on the Saxon scrum with some amusement. They were close enough for her to hear them say something to each other in a kind of base Latin. Then they all laughed. Stepping over a trio of roiling villeins locked in combat on the puddled ground, they continued into the Great Hall with a flourish of cloaks. The bearers hoisted the canopy above their own heads and trudged off.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘You’ve arrived at just the right time,’ Ulf said. ‘The Lady Sibilla’s due any minute and I reckon they’re going to need all the help they can get.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Sibilla?’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Lord Roger’s sister-in-law. Sir Ralph’s wife. After your time. You won’t have met her.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘I wonder if that’s the party I saw on the way over? If so, Sir Ralph was astride a rather mettlesome stallion. Most impressively caparisoned—’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘That’d be Sir Ralph all right.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘And his lady? Hair black as ebony, and wearing a blue velvet cloak?’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘And that’d be the Lady Sibilla. And what a size she is! ’Struth!’ Ulf held his hands in front of an imaginary beer gut. Despite his height and job he was as thin as a lath.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘She didn’t look particularly big to me,’ said Hildegard. ‘Rather slight, I thought. Anyway, the party I saw must have arrived ages ago, the pace they were going.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘They did,’ said Ulf.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘But I thought you just said she was due?’ Hildegard was puzzled.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Due. Yes.’ He blushed. Auburn-blond, he blushed easily and his skin was now nearly the same shade as his beard. He cupped his hands round an imaginary stomach and Hildegard suddenly understood.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘But she was riding astride!’ she exclaimed, rain on her lashes making her blink. ‘And,’ she added in surprise, ‘she must be all of forty.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘That’s why Roger’s going to be pleased to see you.’ He tapped the scrip at her belt which he guessed was full of cures. ‘Many hands make light work.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Too many cooks spoil the broth,’ she replied automatically.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Ulf bent his head close to her ear. Rain dripped off his brow on to her shoulder. ‘On to more important matters, sister. I’ve got a nice keg of Guienne in my pantry.’ He squeezed her elbow. ‘How about coming in later to give me your opinion?’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Let me see how it goes with Lord Roger,’ she told him. ‘I’m not here for rollicking. I have business in mind.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Ignoring his raised eyebrows, she left him. With the intention of getting out of her wet garments as soon as possible, she followed one of the servants through a maze of corridors to one of the guest chambers. She was relieved the journey was behind her. Now she could focus on her mission. But she couldn’t help wondering whether it had been a mistake to come out here after all. What with Martinmas, Lombardy bankers and now a pregnant sister-in-law, would Lord Roger be able to give her the time and attention her project deserved?")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-bf5f2796","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/9781429964555_ch01.vue
// module id = 78
// module chunks = 0